import { keyframes, styled } from '@mui/material';

const backAndForth = keyframes`
  from {
    left: -70%;
    width: 70%;
  }
  to {
    left: 100%;
    width: 70%;
  }
`;

// const backAndForth2 = keyframes`
//     from {
//       padding-left: 0%;
//       padding-right: 100%;
//     }
//     to {
//       padding-left: 100%;
//       padding-right: 0%;
//   }
// `;

export type ProgressBarProps = {
    duration?: number;
};
export const ProgressBar = styled('div', {
    shouldForwardProp: (prop) => !['sx', 'duration'].includes(prop as string),
})<ProgressBarProps>(({ theme, duration = 1000 }) => ({
    width: '100%', // Needed?
    overflow: 'hidden',
    position: 'relative',
    height: 4,
    backgroundColor:
        theme.palette.mode === 'dark'
            ? theme.bino.color.black
            : theme.bino.color.lightGray,
    '&:after': {
        content: '""',
        position: 'absolute',
        bottom: 0,
        height: 4,
        borderRadius: 6,
        backgroundColor: theme.palette.primary.main,
        animationDuration: `${(duration / 1000).toString()}s`,
        animationName: backAndForth,
        animationIterationCount: `infinite`,
        animationDirection: `alternate`,
        animationTimingFunction: `ease-in-out`,
        animationFillMode: 'both',
    },
}));

export default ProgressBar;
